import React, { Component } from 'react';
import questionIcon from '../../../images/question.svg';
import Styled from './styles';
import { META_EVENTS, NOTIFICATION_EVENTS } from '../../../constants/CONTROLLERS_EVENT_TYPES';

class Notifications extends Component<any, any> {
  constructor(props) {
    super(props);

    this.updateNotification = this.updateNotification.bind(this);

    window.Widget.notificationController.addListener(
      NOTIFICATION_EVENTS.UPDATE,
      this.updateNotification,
    );
    window.Widget.metaController.addListener(META_EVENTS.INIT, () => {
      if (window.Widget.metaController.meta.isPeriodical) {
        this.forceUpdate();
      }
    });

    this.state = {
      notification: null,
      // notification: {
      //   title: 'Подсказка',
      //   message: 'Цифры на секторах показывают доступное количество билетов',
      //   type: 'info'
      // },
    };
  }

  updateNotification(notification) {
    this.setState(() => ({ notification }));
  }

  render() {
    const { notification } = this.state;
    const { isPeriodical } = window.Widget.metaController.meta;

    return (
      <Styled.Container isPeriodical={isPeriodical}>
        {notification && (
          <Styled.Message
            type={notification.type}
            onClick={window.Widget.notificationController.hide}
          >
            <Styled.Icon src={questionIcon} />
            {notification.title && <Styled.Title>{notification.title}</Styled.Title>}
            {notification.message}
          </Styled.Message>
        )}
      </Styled.Container>
    );
  }
}

export default Notifications;
